<template>
    <v-row>
        <v-col>
            <v-select
                v-model="period"
                :items="periodList"
                item-text="itemText"
                item-value="itemValue"
                label="ระยะเวลา"
            >
            </v-select>
        </v-col>
        <v-col>
            <DatePicker ref="startDate" label="วันที่เริ่มต้น" @setDate="setStartDate" ></DatePicker>
        </v-col>
        <v-col>
            <DatePicker ref="endDate" label="วันที่สิ้นสุด" @setDate="setEndDate" ></DatePicker>
        </v-col>
    </v-row>
</template>

<script>
import DatePicker from '@/components/Common/DatePicker2'
import moment from 'moment';
export default {
    name: 'PeriodComponent',
    components: {
        DatePicker
    },
    watch: {
        "period": function(val) {
            if (!val || !this.$refs.endDate) return;
            this.$emit("setPeriod", val);
            if (!this.startDate){
                this.startDate = new Date().toISOString().substr(0, 10);
                this.$refs.startDate.setDate(this.startDate);
                return;
            } 
            this.endDate = this.getEndDate(this.startDate, val);
            this.$refs.endDate.setDate(this.endDate);
        },
    },
    data:  () => ({
        period: '',
        startDate: '',
        endDate: '',
        periodList: [
            {itemValue: '1', itemText: '1 เดือน'},
            {itemValue: '2', itemText: '2 เดือน'},
            {itemValue: '3', itemText: '3 เดือน'},
            {itemValue: '4', itemText: '4 เดือน'},
            {itemValue: '5', itemText: '5 เดือน'},
            {itemValue: '6', itemText: '6 เดือน'},
            {itemValue: '7', itemText: '7 เดือน'},
            {itemValue: '8', itemText: '8 เดือน'},
            {itemValue: '9', itemText: '9 เดือน'},
            {itemValue: '10', itemText: '10 เดือน'},
            {itemValue: '11', itemText: '11 เดือน'},
            {itemValue: '12', itemText: '12 เดือน'},
        ]
    }),
    methods: {
        clear(){
            console.log('clear')
            this.period = ''
            this.$refs.startDate.setDate('');
            this.$refs.endDate.setDate('');
        },
        getEndDate(startDate, period) {
            var currentDate = moment(startDate);
            
            var endDate = moment(currentDate).add(period, 'months').format('yyyy-MM-DD');
            return endDate;
        },
        setStartDate(val) {
            this.$emit("setStartDate", val);
            this.startDate = val;
            if (!this.period) return;
            this.endDate = this.getEndDate(this.startDate, this.period);
            this.$refs.endDate.setDate(this.endDate);
        },
        setEndDate(val) {
            this.$emit("setEndDate", val);
            this.endDate = val;
        },
        setDefaultPeriod(val) {
            this.period = val;
        },
        setDefaultStartDate(startDate) {
            this.$refs.startDate.setDate(startDate);
        },
        setDefaultEndDate(endDate) {
            this.$refs.endDate.setDate(endDate);
        }
    },
    mounted() {
        this.period = ''
    }
}
</script>